import type { VoidFunctionComponent } from 'react';

import { Badge, icons } from '../../generic';
import type { PackageLabelAssignmentWithName } from '../../../../shared/model-typings/packagelabelassignment';
import type { IconClassName } from '../../generic';

type Props = {
  label: PackageLabelAssignmentWithName;
  hasDarkBackground?: boolean;
};

/**
 * A badge that displays a Package Label's scope and name.
 */
const PackageLabelBadge: VoidFunctionComponent<Props> = ({ label, hasDarkBackground = false }) => {
  let icon: IconClassName = icons.globeOutline;
  if (label.scope === 'project') {
    icon = icons.folderBookmark;
  } else if (label.scope === 'revision') {
    icon = icons.codeCommit;
  }

  const color = hasDarkBackground ? 'dark-gray' : 'white';

  return (
    <Badge color={color} icon={icon} fullWidth>
      {label.name}
    </Badge>
  );
};

export default PackageLabelBadge;
